const TAP_MOVEMENT_THRESHOLD_PX = 10;

export function isSelectionTap({ start, end }) {
  if (!start || !end) return false;
  return Math.hypot(end.x - start.x, end.y - start.y) < TAP_MOVEMENT_THRESHOLD_PX;
}

export { TAP_MOVEMENT_THRESHOLD_PX };
